import getConfig from "next/config";

import { getNearestPoint } from "@lib/google-maps/getNearestPoint";
import api from "@api";

import {
  TEST_DRIVE_TYPE_ID,
  TEST_DRIVE_HOME_LABEL,
  TEST_DRIVE_POINT_STORE_TYPE,
} from "@shared/constants";

const { publicRuntimeConfig } = getConfig();

const { COUNTRY } = publicRuntimeConfig;

export const getHomeTestDriveInfo = async (address, points, color) => {
  if (!address || !address.city) {
    return false;
  }

  const addressGeoLat = address?.geoLat ?? address?.geoLatitude;

  const addressGeoLng = address?.geoLng ?? address?.geoLongitude;

  const nearest = await getNearestPoint(points, {
    lat: Number(addressGeoLat),
    lng: Number(addressGeoLng),
  });

  const getAddress = () => {
    if (address.address1) {
      return address.address1;
    }

    if (!address?.streetNumber && !address?.street) {
      return "";
    }

    return `${address?.streetNumber ?? ""} ${address?.street ?? ""}`;
  };

  const location = {
    id: TEST_DRIVE_TYPE_ID.HOME,
    type: TEST_DRIVE_TYPE_ID.HOME,
    distanceInMeters: 0,
    name: TEST_DRIVE_HOME_LABEL,
    slug: "home-test-drive",
    address1: getAddress(),
    address2: "",
    city: address?.city,
    country: COUNTRY,
    countryName: address?.country ?? address?.countryName,
    zipcode: address?.zipcode ?? address?.postcode,
    geoLatitude: String(addressGeoLat),
    geoLongitude: String(addressGeoLng),
    concessionIdVC: nearest.concessionIdVC,
    brandId: nearest.brandId,
    RRDICode: "",
    siteGeo: "",
    startEndZoneIdSet: "",
    email: "",
    isDisabled: false,
    isReserved: false,
    storeType: TEST_DRIVE_POINT_STORE_TYPE.HOME,
    _id: TEST_DRIVE_TYPE_ID.HOME,
    colorHexa: color,
  };

  const { data } = await api.getIsParkopolyHomeTestDriveAvailable({ location });

  return {
    isHomeTestDriveAvailable: data?.isHomeTestDriveAvailable,
    homeTestDrivePoint: location,
  };
};
